import React from 'react';
import {
  IconButton, Tooltip, Box, SxProps, Theme,
} from '@mui/material';
import StraightenIcon from '@mui/icons-material/Straighten';
import { useChartRulerContext } from '../../../../../context/ChartRulerContext';

interface ChartRulerButtonProps {
  sx?: SxProps<Theme>;
}

function ChartRulerButton({ sx = {} }: ChartRulerButtonProps) {
  const chartRulerContext = useChartRulerContext();

  if (!chartRulerContext) return null;

  const {
    isRulerActive, rulerPoints, activateRuler, clearRuler,
  } = chartRulerContext;
  const hasBothPoints = rulerPoints[0] !== null && rulerPoints[1] !== null;

  const handleClick = () => {
    if (hasBothPoints) {
      clearRuler();
    } else {
      activateRuler();
    }
  };

  const getTooltipTitle = () => {
    if (!isRulerActive) return 'Regla: colocar líneas verticales en los gráficos';
    if (hasBothPoints) return 'Las líneas están colocadas. Haz clic para limpiar';
    return 'Haz clic en dos puntos de cualquier gráfico para colocar las líneas';
  };
  const tooltipTitle = getTooltipTitle();

  return (
    <Box sx={{
      ...sx,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      mb: 1,
    }}>
      <Tooltip title={tooltipTitle}>
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            padding: '4px',
            gap: '4px',
            backgroundColor: isRulerActive ? 'rgba(56, 85, 118, 0.12)' : 'transparent',
          }}
        >
          <StraightenIcon sx={{ color: '#385576', fontSize: '18px' }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default ChartRulerButton;
